<template>
  <div id="app" ref="app">
    <loading v-show="loading"></loading>
    <base-layout></base-layout>
  </div>
</template>
<script>
  import { mapGetters, mapActions } from 'vuex'
  import BaseLayout from './layouts/BaseLayout.vue'
  import Loading from './layouts/partials/Loading.vue'

  export default {
    name: 'App',
    metaInfo() {
      return {
        meta: [
            {
              'name': 'viewport',
              'content': this.viewport
            },
        ]
      }
    },
    components: {
      BaseLayout,
      Loading,
    },
    created() {
      const self = this
      window.addEventListener('scroll', self.onScroll, !document.documentMode ? { passive: true } : false)
      this.debouncedScroll = _.debounce(this.scrollFunction, 500)
    },
    destroyed() {
      const self = this
      window.removeEventListener('scroll', self.onScroll)
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.handleResize)
    },
    data() {
      return {
        val: 0,
        width: window.innerWidth,
        height: window.innerHeight,
        viewport: '',
      }
    },
    watch: {
      val() {
        this.debouncedScroll()
      }
    },
    computed: {
      ...mapGetters('layout', ['loading']),
    },
    methods: {
      ...mapActions('layout', ['getScroll200', 'setStoreLoading']),
      onScroll() {
        this.val = this.val + 1
      },
      scrollFunction() {
        const self = this
        if (document.body.scrollTop > 200 || document.documentElement.scrollTop > 200) {
          self.getScroll200(true)
        } else {
          self.getScroll200(false)
        }
      },
      handleResize() {
        // resizeのたびにこいつが発火するので、ここでやりたいことをやる
        this.width = window.innerWidth
        const userAgent = window.navigator.userAgent.toLowerCase()
        const isIPad = /iPad|Macintosh/i.test(navigator.userAgent) && 'ontouchend' in document
        if (this.width > 767 && this.width < 1115 && !isIPad) {
          const percent = `${Math.round(this.width / 1115 * 100)}%`
          const decimal = Math.round(this.width / 1115 * 100) / 100
          $(document).ready(() => {
            $('html').css('width', '1088px')
            $('html').css('overflow-x', 'hidden')
            $('body').css('width', '1088px')
            if (userAgent.indexOf('chrome') !== -1) {
              $('body').css('zoom', percent) /* Webkit browsers */
            } else if (userAgent.indexOf('firefox') !== -1) {
              /* eslint no-undef: 0 */
              $('body').css('-moz-transform', scale(decimal, decimal)) /* Moz-browsers */
            } else {
              $('body').css('zoom', decimal) /* Other non-webkit browsers */
            }
          })
        } else {
          $(document).ready(() => {
            $('html').css('width', 'auto')
            $('html').css('overflow-x', 'visible')
            $('body').css('width', 'auto')
            if (userAgent.indexOf('chrome') !== -1) {
              $('body').css('zoom', '100%') /* Webkit browsers */
            } else if (userAgent.indexOf('firefox') !== -1) {
              $('body').css('-moz-transform', scale(1, 1)) /* Moz-browsers */
            } else {
              $('body').css('zoom', 1) /* Other non-webkit browsers */
            }
          })
        }
      }
    },
    mounted() {
      const sleep = msec => new Promise(resolve => setTimeout(resolve, msec));
      (async () => {
        await sleep(0)
        this.setStoreLoading(false)
      })()
      window.addEventListener('resize', this.handleResize)
      const isIPad = /iPad|Macintosh/i.test(navigator.userAgent) && 'ontouchend' in document
      // $('html').css('width', '1088px' );
      // $('html').css('overflow-x', 'hidden' );
      //
      this.width = window.innerWidth
      const userAgent = window.navigator.userAgent.toLowerCase()
      if (this.width > 767 && this.width < 1115 && !isIPad) {
        const percent = `${Math.round(this.width / 1115 * 100)}%`
        const decimal = Math.round(this.width / 1115 * 100) / 100
        $(document).ready(() => {
          $('html').css('width', '1088px')
          $('html').css('overflow-x', 'hidden')
          $('body').css('width', '1088px')
          if (userAgent.indexOf('chrome') !== -1) {
            $('body').css('zoom', percent) /* Webkit browsers */
          } else if (userAgent.indexOf('firefox') !== -1) {
            $('body').css('-moz-transform', scale(decimal, decimal)) /* Moz-browsers */
          } else {
            $('body').css('zoom', decimal) /* Other non-webkit browsers */
          }
        })
      } else {
        $(document).ready(() => {
          $('html').css('width', 'auto')
          $('html').css('overflow-x', 'visible')
          $('body').css('width', 'auto')
          if (userAgent.indexOf('chrome') !== -1) {
            $('body').css('zoom', '100%') /* Webkit browsers */
          } else if (userAgent.indexOf('firefox') !== -1) {
            $('body').css('-moz-transform', scale(1, 1)) /* Moz-browsers */
          } else {
            $('body').css('zoom', 1) /* Other non-webkit browsers */
          }
        })
      }
      let isAndroidTablet = false
      if (userAgent.indexOf('android') > -1 && userAgent.indexOf('mobile') > -1) {
        //
      } else if (userAgent.indexOf('android') > -1 && !userAgent.indexOf('mobile') > -1) {
        isAndroidTablet = true
      }
      if (isIPad) {
        if (window.innerWidth < 1024) {
          this.viewport = 'width=1088, initial-scale=0.7'
        } else {
          this.viewport = 'width=1088, initial-scale=0.94'
        }
      } else if (isAndroidTablet) {
        this.viewport = 'width=1093px, user-scalable=no, target-densitydpi=device-dpi'
      } else {
        this.viewport = 'width=device-width, initial-scale=1.0'
      }
    },
  }
</script>
<style lang="scss">
  @import "./assets/scss/main";
</style>
